import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ExtractorT } from 'routes/Support/models';
import { useDispatch } from 'store/hooks';
import { useAddIntegrationMutationOnCreation } from '../../ClientSupport/components/ClientConfiguration/hooks/updateIntegrations';

type CreateClientParams = {
    body: {
        name: string;
        bind: string;
        teamPassword: string;
        extractorPassword: string;
        logoUrl: string;
        primaryColor?: string;
        secondaryColor?: string;
        extractors: ExtractorT[];
        modules: string[];
        extraFeatures: string[];
        usageHistory: boolean;
    };
    softwares: string[];
};

export const useCreateClientMutation = (onClose: () => void) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    const addIntegrationMutation = useAddIntegrationMutationOnCreation();

    return useMutation({
        mutationFn: (parameters: CreateClientParams) =>
            dispatch.API.post({
                params: {
                    body: parameters.body,
                    endpoint: `support/clients`,
                },
                successAction: () => {
                    addIntegrationMutation.mutate({
                        integrations: parameters.softwares,
                        bind: parameters.body.bind,
                    });
                },
                // @ts-expect-error [TS migration] Was not detected by flow
                failureAction: (status, response) => {
                    dispatch.vision.notifyUser({
                        // @ts-expect-error [TS migration] Was not detected by flow
                        message: Object.values(response.errors),
                    });
                },
            }),

        onSuccess: (response) => {
            queryClient.invalidateQueries({
                queryKey: ['support-clients'],
            });
            dispatch.vision.notifyUser({
                // @ts-expect-error [TS migration] Was not detected by flow
                message: response.message || '',
                snackType: 'success',
            });
            onClose();
        },
    });
};
